var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"persistenceKey":'customer-statement-list',"gcPopupCustomerStatementConfig":_vm.gcPopupCustomerStatementConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }